import { Platform } from 'react-native';
export var getTypoConfig = props => {
  var fontSize = props.fontSize,
    lineHeight = props.lineHeight,
    letterSpacing = props.letterSpacing,
    color = props.color,
    _props$isBold = props.isBold,
    isBold = _props$isBold === void 0 ? false : _props$isBold,
    _props$isSingleLine = props.isSingleLine,
    isSingleLine = _props$isSingleLine === void 0 ? false : _props$isSingleLine,
    _props$isUppercase = props.isUppercase,
    isUppercase = _props$isUppercase === void 0 ? false : _props$isUppercase;
  var typographyStyles = Object.assign(Object.assign({
    fontSize,
    lineHeight,
    letterSpacing,
    color
  }, isSingleLine && Object.assign({}, Platform.OS == 'web' && {
    whiteSpace: 'nowrap'
  })), isUppercase && {
    textTransform: 'uppercase'
  });
  return {
    typographyStyles,
    isUppercase,
    isBold
  };
};